import React from 'react'

const PaymentNotificationSettingsSkeleton = () => (
  <div className="bg-background-secondary [&>*]:flex-1 flex h-fit w-full animate-pulse flex-col gap-7 overflow-x-hidden rounded-md p-5">
    <div className="bg-skeleton-primary rounded-sm py-0.5 text-transparent">.</div>
    <div className="bg-skeleton-primary rounded-sm py-0.5 text-transparent">.</div>
  </div>
)

export default PaymentNotificationSettingsSkeleton
